import { SearchDefinition } from './search-definition';

export class SearchFormParams {

  filterValues: Map<string, string[]>;
  searchFields: SearchDefinition | undefined;

  constructor() {
    this.filterValues = new Map<string, string[]>();
  }

  UpdateValueCache(fieldname: string, list: string[]) {
    if (fieldname == '' || list == undefined || list.length == 0) {
      return;
    }
    if (this.filterValues.has(fieldname)) {
      this.filterValues.delete(fieldname);
    }
    this.filterValues.set(fieldname, list);
  }
}
